module.exports = __webpack_public_path__ + "static/web-optimization-icon-3a5d775b03eb1dd9f3cfc0bbb5964d26.png";